import styled from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';

interface Props {
  color: string;
}

export const TermsAndConditions = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  margin-left: 8px;
`;

export const LinkTermsAndConditions = styled.a`
  color: ${(props: Props) => props.color};
  font-size: 14px;
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 15px;

  @media (min-width ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;

export const PaymentSummary = styled.div`
  margin-top: 10px;
  font-family: ${FONTS.OPEN_SANS};
  padding: 4px 6px;
  background-color: ${(props: Props) => props.color};
  border-radius: 4px;
  width: 100%;
  font-size: 12px;

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

PaymentSummary.displayName = 'PaymentSummary';

export const SummaryDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  margin: 4px 0;
`;

SummaryDescription.displayName = 'SummaryDescription';

export const TextDescription = styled.div`
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
`;

TextDescription.displayName = 'TextDescription';